<template>
    <div id="hero">
        <!-- DESKTOP -->
        <div class="hidden sm:flex relative bg-[#005ebc] overflow-hidden">
            <div class="mx-auto max-w-[1400px] w-full lg:px-24 px-12 h-full flex flex-col">
                <div class="flex justify-between items-end">
                    <div class="w-52 h-[75px] bg-white rounded-b-xl shrink-0 grid place-items-center"
                        style="box-shadow: 4px 4px 25px 0px rgba(0,0,0,0.3);">
                        <img src="@/assets/logo-centered.png" class="w-9/12" draggable="false" alt="Evangelische Kirche in Mitteldeutschland">
                    </div>
                    <div class="flex gap-6 md:flex hidden">
                        <template v-for="i in nav" :key="i">
                            <button class="select-none text-white font-thin text-sm lg:text-base py-2
                        hover:font-normal underline-offset-4 cursor-pointer duration-100" @click="$router.push(i.path)"
                                :style="`width: ${i.label.length * 10}px;`">{{ i.label
                                }}</button>
                        </template>
                    </div>
                </div>
                <div class="flex justify-between mt-24">
                    <div class="-ml-1.5 fadeIn" style="--delay: .8s;">
                        <p class="font-thin text-white text-[3.4rem] md:text-[4.1rem] scale-y-[1.2]">Kirchspiel</p>
                        <p class="font-bold text-white text-[2.6rem] md:text-[3.1rem] -mt-2 scale-y-[1.2]">Rastenberg
                        </p>
                    </div>
                    <p class="text-right text-[1.3rem] md:text-[1.8rem] text-white font-thin mt-3 fadeIn"
                        style="--delay: .8s;">Herzlich
                        Willkommen,<br>in unserer
                        kleinen<br>Gemeinde.</p>
                </div>
                <div class="w-full flex-auto mt-24 relative slideIn"
                    style="--delay: .3s; filter: drop-shadow(0 0 0.75rem rgba(0,0,0,.2));">
                    <button @click="$router.push('/#grid')"
                        class="bg-gray-800 hover:bg-gray-900 duration-100 p-2 h-[15%] aspect-square grid place-items-center rounded-full absolute -m-[1.25%] top-0 right-0 cursor-pointer z-30" aria-label="Zur Themenübersicht scrollen">
                        <svg class="size-[50%] text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                            <path
                                d="M5.027 10.9a8.729 8.729 0 0 1 6.422-3.62v-1.2A2.061 2.061 0 0 1 12.61 4.2a1.986 1.986 0 0 1 2.104.23l5.491 4.308a2.11 2.11 0 0 1 .588 2.566 2.109 2.109 0 0 1-.588.734l-5.489 4.308a1.983 1.983 0 0 1-2.104.228 2.065 2.065 0 0 1-1.16-1.876v-.942c-5.33 1.284-6.212 5.251-6.25 5.441a1 1 0 0 1-.923.806h-.06a1.003 1.003 0 0 1-.955-.7A10.221 10.221 0 0 1 5.027 10.9Z" />
                        </svg>

                    </button>
                    <img src="@/assets/hero_16x9.png" class="w-full aspect-video overflow-hidden" style="
                    mask-image: url('/assets/masks/hero-img-mask.svg');
                    mask-size: contain;
                    mask-position: top;
                    mask-repeat: no-repeat;"
                    alt="Bild der Rastenberger Kirche">
                    <img src="/assets/masks/hero_transparent.png" class="w-full absolute bottom-[-6%] left-0" alt="">
                </div>
            </div>
        </div>

        <!-- MOBILE -->
        <div class="w-full relative overflow-hidden sm:hidden flex flex-col bg-[#005ebc] h-screen"
            style="min-width: 300px;">

            <div class="w-52 h-[75px] bg-white rounded-b-xl shrink-0 grid place-items-center mx-12"
                style="box-shadow: 4px 4px 25px 0px rgba(0,0,0,0.3);">
                <img src="@/assets/logo-centered.png" class="w-9/12" draggable="false">
            </div>

            <div class="-ml-1.5 flex flex-col items-start px-12 my-12 fadeIn" style="--delay: .8s">
                <p class="font-thin text-white text-[3.0rem] scale-y-[1.2]">Kirchspiel</p>
                <p class="font-bold text-white text-[2.3rem] -mt-2 scale-y-[1.2]">Rastenberg
                </p>
            </div>

            <div class="flex-auto flex relative ml-12 slideInRight" style="--delay: .3s;">
                <button @click="$router.push('/#grid')"
                    class="bg-gray-800 hover:bg-gray-900 duration-100 p-2 w-[18%] 
                    aspect-square grid place-items-center rounded-full absolute -m-[4%] bottom-0 left-0 cursor-pointer z-30">
                    <svg class="size-[50%] text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                        height="24" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M5.027 10.9a8.729 8.729 0 0 1 6.422-3.62v-1.2A2.061 2.061 0 0 1 12.61 4.2a1.986 1.986 0 0 1 2.104.23l5.491 4.308a2.11 2.11 0 0 1 .588 2.566 2.109 2.109 0 0 1-.588.734l-5.489 4.308a1.983 1.983 0 0 1-2.104.228 2.065 2.065 0 0 1-1.16-1.876v-.942c-5.33 1.284-6.212 5.251-6.25 5.441a1 1 0 0 1-.923.806h-.06a1.003 1.003 0 0 1-.955-.7A10.221 10.221 0 0 1 5.027 10.9Z" />
                    </svg>

                </button>
                <img src="@/assets/hero-img.jpg" class="object-cover rounded-l-xl
                flex-auto z-10" alt="Bild der Rastenberger Kirche" style="
                    mask-image: url('/assets/masks/hero-img-mask-mobile.svg');
                    mask-size: 180%;
                    mask-position: bottom left;
                    mask-repeat: no-repeat;
                ">
            </div>

            <p class="text-right text-[1.3rem] md:text-[1.8rem] text-white font-thin mt-3 mb-12 
            pt-6 mx-6 fadeIn" style="--delay: .8s">Herzlich
                Willkommen,<br>in unserer
                kleinen<br>Gemeinde.</p>

            <!-- <div class="mt-10 flex z-10">
                <button class="h-16 w-28 bg-card-dark rounded-t-3xl mx-auto" @click="scrollTo('#grid')">
                    <img src="@/assets/icons/arrow-down.png" class="invert h-9 mx-auto"
                        alt="Pfeil nach unten, um zum Inhalt zu navigieren">
                </button>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "Hero",

    data() {
        return {
            nav: [
                {
                    label: "Unsere Kirchen",
                    path: "/#churches"
                },
                {
                    label: "Themenwelt",
                    path: "/#grid"
                },
                {
                    label: "Schmetterling",
                    path: "/#butterfly"
                },
                {
                    label: "Kontakt",
                    path: "/#contact"
                },
            ]
        }
    },

    methods: {
        scrollTo(el) {
            window.lenis.scrollTo(el, { offset: -200 })
        }
    }
}
</script>

<style>
.slideInRight {
    opacity: 0;
    animation: slideInRight .5s ease var(--delay) forwards;
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(10%);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.slideIn {
    opacity: 0;
    animation: slideIn .5s ease var(--delay) forwards;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(10%);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.fadeIn {
    opacity: 0;
    animation: fadeIn .5s ease var(--delay) forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>